<template>
  <div id="app">
    <FormParticleTrail />
    <TerminalLocationPermissionDialog />
    <router-view />
  </div>
</template>

<script>
import FormParticleTrail from '@/components/FormParticleTrail'
import TerminalLocationPermissionDialog from '@/components/TerminalLocationPermissionDialog'
import { applyTerminalSkin } from '@/utils/appearance'

export default {
  name: 'App',
  components: { FormParticleTrail, TerminalLocationPermissionDialog },
  computed: {
    skin () { return this.$store.getters['app/getTerminalSkin'] }
  },
  watch: {
    skin: { immediate: true, handler: applyTerminalSkin }
  }
}
</script>
<style>
#app {
  height: 100%;
}
</style>
